export class RecaptchaError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'RecaptchaError';
    Object.setPrototypeOf(this, RecaptchaError.prototype);
  }
}
